// extracted by mini-css-extract-plugin
export default {"container":"NotificationsView_container__qxdTp","alert":"NotificationsView_alert__7+Zq0"};